import { formatUserIdToJid, getUserDetails } from '../../Helpers/Chat/User';
import { getThumbBase64URL, getTimeAgo } from '../../Helpers/Utility';

const StoriesCard = ({ title, items, isViewed, onShowPreview }) => {
    return (
        <>
            {items.length > 0 && <p className="stories-type">{title}</p>}

            {items.map((item, index) => {
                const latestStory = item.stories?.at(-1) ?? null;
                const { displayName, initialName, name, nickName } = getUserDetails(formatUserIdToJid(item?.userId));

                return (
                    <li
                        className="stories-list-li"
                        role="button"
                        tabIndex={0}
                        key={index}
                        onClick={() => {
                            onShowPreview(item);
                        }}
                    >
                        <div className={`image ${isViewed ? 'in-active' : 'active'}`}>
                            <img src={getThumbBase64URL(latestStory?.thumbImage)} alt="aaaa" />
                        </div>

                        <div className="stories-details">
                            <h3 className="userName">{displayName || initialName || name || nickName}</h3>
                            <span className="content">{getTimeAgo(item?.lastUpdatedAt)}</span>
                        </div>
                    </li>
                );
            })}
        </>
    );
};

export default StoriesCard;
